import { Flex, Divider, Box, Image, Text, useDisclosure } from '@chakra-ui/react';

//import { TransmissionIcon } from '../../../components/Icons/Icons';

import { ReactComponent as TransmissionIcon } from '../../../assets/transmission-icon.svg';
import { MdToken } from 'react-icons/md';

const ScaledNumber = ({ value, minSource, maxSource, minTarget = 2, maxTarget = 6 }) => {
  const scaleNumber = (num) => {
    // Линейное масштабирование
    return minTarget + ((num - minSource) * (maxTarget - minTarget)) / (maxSource - minSource);
  };

  const scaledValue = Math.min(maxTarget, Math.max(minTarget, scaleNumber(value))); 

  const styleDivider = {
		background: '#bdbdbd',
		height: '0.1em',
		position: 'relative',
		width: '10px'
  };

  const countDividerTransmission = 6;

  return (
  	<>
	    <Box 
	    	transition="0.3s all" 
	    	top="38%" 
		    left="-40px"
		    position="absolute"
		    borderRadius="6px"
		    overflow="visible"
	    	position="absolute"
	    	_before={{
			    content: '""',
			    position: 'absolute',
			    right: '-5px',
			    top: '50%', 
			    transform: 'translateY(-50%)',
			    width: '0',
			    height: '0',
			    borderStyle: 'solid',
			    borderWidth: '5px 0 5px 5px',
			    borderColor: 'transparent transparent transparent #71fff9',
			}}
			_after={{
			    content: '""',
			    position: 'absolute',
			    right: '-3px',
			    top: '50%', 
			    transform: 'translateY(-50%)',
			    width: '0',
			    height: '0',
			    borderStyle: 'solid',
			    borderWidth: '5px 0 5px 5px',
			    borderColor: 'transparent transparent transparent #244244',
			}}
	    	>
			    <Flex
			    	position="absolute"
			    	zIndex="2"
			    	transition="0.3s all"
			    	opacity={value > 50 ? 1 : 0}
			    	mt="-22px"
			    	gap="2px">
			    	<MdToken color="#71fff9" style={{marginTop: '-1px'}} />
			    	<Text variant="title-sm" color="#71fff9">x{Math.round(scaledValue / 2.4)}</Text>
			    </Flex>

			    <Text
			      	bg="#194443"
			      	borderRadius="6px"
			      	border="1px solid #71fff9"
			      	w="30px"
			      	padding="5px 6px"
			      	textAlign="center"
				    color="#71fff9"
				    fontWeight="900"
			      	><TransmissionIcon style={{ width: '16px'}} /></Text>
	    </Box>

	    

	    <Box 
	    	w="30px" 
	    	h="100%"
	    	overflow="hidden">
	    	<Box h="100%" overflow="visible" mt="-269px">
			    <Box 
			    	opacity="0.9" 
			    	transition="0.3s all" 
			    	mt={`${(scaledValue * 50)}px`} 
			    	left="0" 
			    	h="200%">
					{Array.from({ length: countDividerTransmission }).map((_, index) => (
					  <Box 
					  	overflow="visible"
					  	key={index} 
					  	mt="45px"
					  	_before={{
						    content: `"${countDividerTransmission - index}"`,
						    position: 'absolute',
						    top: '-8px',
						    fontSize: '11px',
							right: '-10px',
							color: '#bdbdbd'
						}}
					  	style={styleDivider} />
					))}
				</Box>
			</Box>
		</Box>
	</>
  );
};

const Transmission = ({
	speedNum,
	maxSource
}) => {
	return (
		<Box
		  zIndex="9"
		  overflow="visible"
		  h="160px"
		  w="10px"
		  right="30px"
		  top="250px"
		  position="absolute"
		  /*_before={{
		    content: '""',
		    position: 'absolute',
		    bottom: '0px',
		    left: '0',
		    right: '0',
		    height: '40px',
		    background: 'linear-gradient(to bottom, rgba(0, 0, 0, 0), #03050C)',
		    zIndex: '1',
		    transform: 'rotate(0deg)',
		    width: '40px'
		  }}*/
		  /*_after={{
		    content: '""',
		    position: 'absolute',
		    top: '0px',
		    left: '0',
		    right: '0',
		    height: '40px',
		    background: 'linear-gradient(to top, rgba(0, 0, 0, 0), #03050C)',
		    zIndex: '1',
		    transform: 'rotate(0deg)',
		    width: '40px'
		  }}*/
		>
		  <ScaledNumber value={speedNum} minSource={50} maxSource={maxSource} />
		</Box>
	);
};

export default Transmission;
